import React, { useState } from 'react';
import UserDropdown from './UserDropdown';
import { useNavigate } from 'react-router-dom';
import ChangePasswordModal from './ChangePasswordModal';
import Notification from './Notification';
import SubscriptionDetailsModal from './SubscriptionDetailsModal';
import { logout } from '../utils/authApi';

export default function Header({ type, showAccountDropdown = true }) {
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [notification, setNotification] = useState({ message: '', type: 'success' });
    const [showSubscriptionDetailsModal, setShowSubscriptionDetailsModal] = useState(false);
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        sessionStorage.clear();
        navigate('/');
    };

    const handlePasswordChanged = () => {
        setNotification({ message: 'Password changed successfully!', type: 'success' });
    }

    return (
        <div className="container mx-auto">
            <Notification message={notification.message} onClose={() => setNotification({ message: '', type: 'success' })} type={notification.type} />

            {type !== 'small' && (
                <header className="text-center mb-10 font-sans">
                    <div className="relative inline-block mb-4">
                        <img
                            src="/logo.png"
                            alt="Eternal Locker™ Logo"
                            className="w-24 h-24 sm:w-32 sm:h-32 md:w-48 md:h-48 mx-auto object-contain shadow-xl rounded-full p-1 bg-background-dark"
                            onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/96x96/000000/ffffff?text=EL"; }}
                        />
                        <span className="absolute top-1 -right-1 sm:top-4 sm:right-2 text-[12px] font-bold leading-none rounded-full px-1.5 py-1 shadow-sm" style={{color: "#d9bd8a", borderColor: "#d9bd8a"}}>TM</span>
                    </div>
                    <h1 className="text-3xl font-extrabold text-white tracking-wide" style={{color: "#d9bd8a"}}>
                        ETERNAL LOCKER™
                    </h1>
                    <p className="mt-1 text-lg text-accent-main">Secure your legacy, forever.</p>
                </header>
            )}

            {type === 'small' && (
                <header className="flex items-center gap-3 mb-4 px-2 py-2 bg-background-dark rounded-lg shadow font-sans">
                    <div className="flex items-center gap-2" onClick={() => { navigate('/dashboard') }} style={{ cursor: 'pointer' }}>
                    <div className="relative inline-block mr-2">
                        <img
                            src="/logo192.png"
                            alt="Eternal Locker™ Logo"
                            className="w-10 h-10 object-contain rounded-full bg-background-dark shadow"
                            onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/40x40/000000/ffffff?text=EL"; }}
                        />
                        <span className="absolute -top-0 -right-3 text-[8px] font-bold leading-none rounded-full px-1 py-[2px] shadow-sm" style={{color: "#d9bd8a", borderColor: "#d9bd8a"}}>TM</span>
                    </div>
                    <h1 className="text-xl font-bold text-white tracking-wide" style={{color: "#d9bd8a"}}>Eternal Locker™</h1>
                    </div>
                    {showAccountDropdown && (
                        <div className="flex-1 flex justify-end items-center gap-2">
                            <UserDropdown onLogout={handleLogout} onChangePassword={() => setShowChangePassword(true)} onSubscription={() => setShowSubscriptionDetailsModal(true)} />
                        </div>
                    )}
                </header>
            )}
            {showAccountDropdown && (
                <>
                    <ChangePasswordModal
                        open={showChangePassword}
                        onClose={() => setShowChangePassword(false)}
                        onSuccess={handlePasswordChanged}
                    />
                    <SubscriptionDetailsModal
                        open={showSubscriptionDetailsModal}
                        onClose={() => setShowSubscriptionDetailsModal(false)}
                        onCancelSubscription={handleLogout}
                    />
                </>
            )}
        </div>
    );
}
